import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, AlertCircle } from "@opendate-app/setlist";

const PublishCheckModal = ({ title, warnings, saving, onFix, onCancel, onPublish }) => (
  <Modal
    open
    onClose={saving ? () => {} : onCancel}
    icon={false}
    width={620}
    title={`Before you publish ${title}`}
    description={`${warnings.length} ${warnings.length === 1 ? "thing" : "things"} won't work the way the setup suggests. None of them stop you from publishing, but each changes what fans see.`}
    footer={(
      <>
        <Button variant="secondary" onClick={onCancel} disabled={saving}>Back to setup</Button>
        <Button variant="primary" onClick={onPublish} disabled={saving}>
          {saving ? "Publishing…" : "Publish anyway"}
        </Button>
      </>
    )}
  >
    <ul className="series-publish-check-list">
      {warnings.map((warning) => (
        <li key={warning.key} className="series-publish-check-item">
          <AlertCircle size={16} className="series-publish-check-icon" />
          <div className="series-publish-check-text">
            <div className="series-publish-check-title">{warning.title}</div>
            <div className="series-publish-check-body">{warning.body}</div>
          </div>
          <Button variant="link-color" size="sm" onClick={() => onFix(warning)}>{warning.fix}</Button>
        </li>
      ))}
    </ul>
  </Modal>
);

PublishCheckModal.propTypes = {
  title: PropTypes.string.isRequired,
  warnings: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    step: PropTypes.string.isRequired,
    sub_tab: PropTypes.string,
    show_type: PropTypes.string,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    fix: PropTypes.string.isRequired,
  })).isRequired,
  saving: PropTypes.bool,
  onFix: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
};

export default PublishCheckModal;
